import { Card } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import TaskItem from './TaskItem';
import { GenericTaskItem, TaskData, TaskActionData } from './types';
import './GenericTaskList.scss';

interface GenericTaskListProps {
  items: GenericTaskItem[];
  onAction: (item: TaskData & TaskActionData) => void;
  onSkip?: (item: TaskData & TaskActionData) => void;
  className?: string;
  paddingVertical?: '2' | '4';
  variant?: 'default' | 'recommendations';
}

function GenericTaskList({
  items,
  onAction,
  onSkip,
  className = '',
  paddingVertical = '4',
  variant = 'default',
}: GenericTaskListProps) {
  const baseClassName = 'stratus--generic-task-list';
  const variantClassName =
    variant === 'recommendations' ? 'recommendations' : '';
  const fullClassName =
    `${baseClassName} ${variantClassName} ${className}`.trim();

  return (
    <div className={fullClassName}>
      <Card padding="none">
        <DataList>
          {items.map((item) => (
            <TaskItem
              key={item.id}
              data={item}
              contentType={item.contentType}
              actionType={item.actionType}
              onAction={onAction}
              onSkip={onSkip}
              paddingVertical={paddingVertical}
            />
          ))}
        </DataList>
      </Card>
    </div>
  );
}

export default GenericTaskList;
